"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RadioButton.css");
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioGroup.prototype._getRadioGroupProps = function () {
        var _a = this.props, id = _a.id, ariaLabelledBy = _a.ariaLabelledBy, isEnabled = _a.isEnabled, style = _a.style, tag = _a.tag, errorMessage = _a.errorMessage, isInline = _a.isInline;
        var groupClasses = ['p-radio-group', style];
        if (errorMessage) {
            groupClasses.push('is-invalid');
        }
        if (!isEnabled) {
            groupClasses.push('is-disabled');
        }
        if (isInline) {
            groupClasses.push('is-inline');
        }
        return {
            id: id,
            'aria-labelledby': ariaLabelledBy,
            className: groupClasses.join(' '),
            'data-tag': tag,
            role: 'radiogroup'
        };
    };
    RadioGroup.prototype.render = function () {
        var _a = this.props, legend = _a.legend, children = _a.children, errorMessage = _a.errorMessage, isRequired = _a.isRequired;
        return (React.createElement("div", null,
            React.createElement("div", __assign({}, this._getRadioGroupProps(), { "aria-required": isRequired }),
                legend && (React.createElement("legend", null,
                    legend,
                    isRequired && React.createElement("span", { className: "p-t-error50" }, "*"))),
                children),
            errorMessage && React.createElement("p", { className: "error p-t-error50" }, errorMessage)));
    };
    return RadioGroup;
}(React.Component));
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/radio-button/build/control/RadioGroup.js
// module id = 702
// module chunks = 0